import { createSlice } from "@reduxjs/toolkit"
import {
  getAllCountries,
  updateCountryStatus,
} from "store/actions/countriesAction"
import {
  getDashboardKpi,
  getDashboardKpiBookings,
  getDashboardKpiOrder,
  getDashboardKpiRatings,
  getWalletDashboard
} from "store/actions/dashboardAction"

const initialState = {
  loading: true,
  dashboardData: {},
  dashboardOrderData: {},
  dashboardBookingsData: {},
  dashboardRatingsData: {},
  walletDashboardData:{}
}

const usersSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET DASHBOARD DATA
    builder
      .addCase(getDashboardKpi.pending, state => {
        state.loading = true
      })
      .addCase(getDashboardKpi.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardData = data
        }
      })
      .addCase(getDashboardKpi.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD ORDER DATA
    builder
      .addCase(getDashboardKpiOrder.pending, state => {
        state.loading = true
      })
      .addCase(getDashboardKpiOrder.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardOrderData = data
        }
      })
      .addCase(getDashboardKpiOrder.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD BOOKINGS DATA
    builder
      .addCase(getDashboardKpiBookings.pending, state => {
        state.loading = true
        state.dashboardBookingsData = {}
      })
      .addCase(getDashboardKpiBookings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardBookingsData = data
        }
      })
      .addCase(getDashboardKpiBookings.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD RATINGS DATA
    builder
      .addCase(getDashboardKpiRatings.pending, state => {
        state.loading = true
        state.dashboardRatingsData = {}
      })
      .addCase(getDashboardKpiRatings.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload || {}
        if (status) {
          state.dashboardRatingsData = data
        }
      })
      .addCase(getDashboardKpiRatings.rejected, (state, action) => {
        state.loading = false
      })

    // GET DASHBOARD WALLET DATA
    builder
    .addCase(getWalletDashboard.pending, state => {
      state.loading = true
      state.walletDashboardData = {}
    })
    .addCase(getWalletDashboard.fulfilled, (state, action) => {
      state.loading = false
      const { status, data } = action.payload || {}
      if (status) {
        state.walletDashboardData = data
      }
    })
    .addCase(getWalletDashboard.rejected, (state, action) => {
      state.loading = false
    })
  },
})

export default usersSlice.reducer
